export class ContactPerson {
    ID?: number;
    CONTACT_MECHANISMS_ID?: number;
    FIRST_NAME?: string;
    LAST_NAME?: string;
    CREATED_BY?: string;
    CREATED_DATE?: Date; // "/Date(-62135568000000)/"
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
}
